// @flow
import * as React from 'react';

import './NavSidebar.scss';

type Props = {
    children: React.Node,
    className?: string,
};

const NavSidebar = ({ children, className = '', ...rest }: Props) => (
    <aside className={`nav-sidebar ${className}`} {...rest}>
        {children}
    </aside>
);

export default NavSidebar;
